import login from '@/views/login/login'
import resetPassword from '@/views/login/resetPassword'
import changePassword from '@/views/login/changePassword'


const meta = {
  auth: false,
  layout: 'default'
}

export default [
  {
    path: '/login',
    name: 'login',
    component: login,
    meta
  },
  {
    path: '/recuperar-palavra-passe',
    name: 'resetPassword',
    component: resetPassword,
    meta
  },
  {
    path: '/alterar-palavra-passe/:token',
    name: 'changePassword',
    component: changePassword,
    meta
  },
]